enum OEConnectEnvironment {
    Dev= 'development',
    Stage= 'stage',
    Prod= 'prod',
}
/* Remove relatively to the build spec */
abstract class IRuntimeConfiguration {
    abstract getApiRoot(): string;
    abstract getAppDomain(): string;
    abstract getBaseUrl(): string;
    abstract getEnv(): OEConnectEnvironment;
    abstract getFusionAuthDomain(): string;
    abstract useCookieAuth(): boolean;
}

export { IRuntimeConfiguration, OEConnectEnvironment };
